/**
 * remoteLog.js
 * Grava logs de diagnóstico em Firestore (coleção `app_logs`).
 * Falha silenciosamente — nunca pode quebrar o fluxo principal.
 *
 * Uso:
 *   import { remoteLog } from 'utils/remoteLog';
 *   remoteLog('error', 'session_refresh_failed', 'Token expirado', { code: err.code });
 */
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../firebase';

/** Extrai um rótulo curto do User-Agent para diagnóstico mobile */
function parseUA(ua = '') {
  let os = 'Desconhecido';
  let browser = '';
  if (/iPhone/i.test(ua))        os = 'iPhone';
  else if (/iPad/i.test(ua))     os = 'iPad';
  else if (/Android/i.test(ua))  os = `Android ${(ua.match(/Android ([^;)]+)/i) || [])[1] || ''}`.trim();
  else if (/Windows/i.test(ua))  os = 'Windows';
  else if (/Mac OS X/i.test(ua)) os = 'macOS';
  else if (/Linux/i.test(ua))    os = 'Linux';

  if (/CriOS/i.test(ua))         browser = 'Chrome iOS';
  else if (/FxiOS/i.test(ua))    browser = 'Firefox iOS';
  else if (/EdgiOS/i.test(ua))   browser = 'Edge iOS';
  else if (/Chrome/i.test(ua))   browser = `Chrome ${(ua.match(/Chrome\/([\d.]+)/i) || [])[1] || ''}`.trim();
  else if (/Safari/i.test(ua))   browser = `Safari ${(ua.match(/Version\/([\d.]+)/i) || [])[1] || ''}`.trim();
  else if (/Firefox/i.test(ua))  browser = 'Firefox';

  return browser ? `${os} / ${browser}` : os;
}

/**
 * @param {'info'|'warn'|'error'} level
 * @param {string} event   identificador curto, ex: 'session_refresh_failed'
 * @param {string} message mensagem legível
 * @param {object} [extra] dados adicionais (será serializado)
 */
export async function remoteLog(level, event, message, extra = {}) {
  try {
    const u  = auth.currentUser;
    const ua = navigator.userAgent || '';

    // Serializa extras tratando objetos Error
    const safeExtra = JSON.parse(
      JSON.stringify(extra, (_, v) => {
        if (v instanceof Error) {
          return { message: v.message, code: v.code, stack: (v.stack || '').slice(0, 400) };
        }
        return v;
      })
    );

    await addDoc(collection(db, 'app_logs'), {
      ts:       serverTimestamp(),
      level,
      event,
      uid:      u?.uid   || null,
      email:    u?.email || null,
      device:   parseUA(ua),
      ua:       ua.slice(0, 300),
      screen:   `${window.screen?.width ?? '?'}x${window.screen?.height ?? '?'}`,
      url:      window.location.pathname,
      message:  String(message).slice(0, 500),
      extra:    safeExtra,
    });
  } catch {
    // Silencioso — jamais pode quebrar o fluxo principal
  }
}
